// extracted by mini-css-extract-plugin
export default {"topPart":"zAcBlz","texts":"u2TTRN","subTitle":"Ote0uv","searchAgain":"kAI1jO","categories":"_k0YwX"};